// ----
// Maps
// ----
function renderDirections(event, response){
	var route = response.routes[0],
		_directions = $(this);
		_LegHeader = $('<h3 class="leg-title"></h3>'),
		_Leg = $('<ol class="leg" />'),
		_Step = $('<li class="step" />'),
		_Distance = $('<span class="distance" />');

	_directions.children().remove();

	// Each leg
	for (var i = 0; i < route.legs.length; i++) {
		var leg = route.legs[i];
		var _thisLeg = _Leg.clone();
		var _thisLegHeader = _LegHeader.clone();


		for (var i = 0; i < leg.steps.length; i++) {
			var step = leg.steps[i];
			var _thisStep = _Step.clone();
			_thisStep
				.html(step.instructions);

			_Distance
				.clone()
				.html(step.distance.text)
				.prependTo(_thisStep);

			_thisStep
				.appendTo(_thisLeg);
		}

		_thisLeg
			.appendTo(_directions);
	}

	$(document.querySelector('.mode-select'))
		.trigger('updateHeight');
}

function clearDirections(event){
	var _directions = $(this);
	_directions.children().remove();
}

$('.js-map')
	.each(function(index, element){
		const ageas = { lat: 50.9241379, lng: -1.3222861 };
		const map = new google.maps.Map(document.getElementById("js-map"), {
			zoom: 16,
			center: ageas,
		});
	});

$('.js-center-map')
	.on('click', function(){
		var _this = $(this),
			m = $('.js-contact-map').data('map');

		_this
			.addClass('active')
			.siblings()
				.removeClass('active');

		if (m !== undefined) {
			m.setCenter(_this.data('postcode'));
		}
	})
	.first()
		.click();

$('.js-directions')
	.on('renderDirections', renderDirections)
	.on('clearDirections', clearDirections);

var Geocoder = new google.maps.Geocoder();
var DirectionsService = new google.maps.DirectionsService();

function createMap(map, location) {
	var mapobj = {},
		_map = $(map),
		callback = null;

	if (arguments[2] !== undefined) {
		callback = arguments[2];
	}

	location = location ? location : 'BH1 1HL';

	Geocoder.geocode(
		{
			address: location
		},
		function(result, status){
			if (status === 'OK') {
				var lat = result[0].geometry.location.lat(),
					lng = result[0].geometry.location.lng();

				var mapOptions = {
					center: new google.maps.LatLng(lat, lng),
					mapTypeId: google.maps.MapTypeId.ROADMAP,
					scrollwheel: false,
					zoom: 8
				};

				mapobj = new google.maps.Map(map, mapOptions);

				var marker = new google.maps.Marker({
					map: mapobj,
					position: new google.maps.LatLng(lat, lng)
				});

				var directionsDisplay = new google.maps.DirectionsRenderer();
				directionsDisplay.setMap(mapobj);

				_map
					.data('map', mapobj)
					.data('directions', directionsDisplay);

				google.maps.event.addListenerOnce(mapobj, 'idle', function(){
					_map
						.trigger('mapIdle');
				});

				if (callback !== null) {
					callback(mapobj);
				}
			}

		}
	);
	return mapobj;
}

function addMarker(map, location) {
	Geocoder.geocode({
		address: location
	},
	function(result, status){
		if (status === 'OK') {
			var lat = result[0].geometry.location.lat(),
				lng = result[0].geometry.location.lng();

			var marker = new google.maps.Marker({
				map: map,
				position: new google.maps.LatLng(lat,lng)
			});
		}
	});
}

function getDirections(start, end, mode, directionsObj) { // Optional argument for a results panel //

	var args = arguments,
		request = {
			origin:start,
			destination:end,
			travelMode: mode,
			unitSystem: google.maps.UnitSystem.IMPERIAL
		},
		result;

	DirectionsService.route(request, function(response, status) {
		if (status == google.maps.DirectionsStatus.OK) {
			directionsObj.setDirections(response);

			if (args[4]) { // Optional
				args[4].trigger('renderDirections', [response]);
			}
		}
	});
}

function getMode(mode) {
	switch (mode) {
		case 'car':
			return google.maps.DirectionsTravelMode.DRIVING;
			break;
		case 'train':
			return google.maps.DirectionsTravelMode.TRANSIT;
			break;
		case 'walk':
			return google.maps.DirectionsTravelMode.WALKING;
			break;
		case 'bicycle':
			return google.maps.DirectionsTravelMode.BICYCLING;
			break;
		case 'intl':
			return google.maps.DirectionsTravelMode.TRANSIT;
			break;
		default:
			return google.maps.DirectionsTravelMode.DRIVING;
	}
}

var map = function (element) {
	var map = this,
		element = element,
		mapobj,
		mapOptions = {
			center: new google.maps.LatLng(0,0),
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			scrollwheel: false,
			zoom: 12
		},
		cacheLoc = {},
		transportMode = google.maps.DirectionsTravelMode.DRIVING,
		directionsDisplay = new google.maps.DirectionsRenderer();

	mapobj = new google.maps.Map(element, mapOptions);
	directionsDisplay.setMap(mapobj);

	this.addMarker = function(location){
		if (cacheLoc[location] !== undefined) {
			var lat = cacheLoc[location].lat,
				lng = cacheLoc[location].lng;

			var marker = new google.maps.Marker({
				map: mapobj,
				position: new google.maps.LatLng(lat,lng)
			});
		} else {
			Geocoder.geocode(
				{
					address: location
				},
				function(result, status){
					if (status === 'OK') {
						var lat = result[0].geometry.location.lat(),
							lng = result[0].geometry.location.lng();

						var marker = new google.maps.Marker({
							map: mapobj,
							position: new google.maps.LatLng(lat,lng)
						});

						cacheLoc[location] = {
							lat: lat,
							lng: lng
						};
					}
				}
			);
		}
	};

	this.setCenter = function(location){
		if (cacheLoc[location] !== undefined) {
			var lat = cacheLoc[location].lat,
				lng = cacheLoc[location].lng;

			mapobj.setCenter(new google.maps.LatLng(lat,lng));
		} else {
			Geocoder.geocode(
				{
					address: location
				},
				function(result, status){
					if (status === 'OK') {
						var lat = result[0].geometry.location.lat(),
							lng = result[0].geometry.location.lng();

						mapobj.setCenter(new google.maps.LatLng(lat,lng));

						cacheLoc[location] = {
							lat: lat,
							lng: lng
						};
					}
				}
			);
		}
	};

	this.setTransportMode = function (mode) {
		switch (mode) {
			case 'car':
				transportMode = google.maps.DirectionsTravelMode.DRIVING;
				break;
			case 'train':
				transportMode = google.maps.DirectionsTravelMode.TRANSIT;
				break;
			case 'walk':
				transportMode = google.maps.DirectionsTravelMode.WALKING;
				break;
			case 'bicycle':
				transportMode = google.maps.DirectionsTravelMode.BICYCLING;
				break;
			case 'intl':
				transportMode = google.maps.DirectionsTravelMode.TRANSIT;
				break;
			default:
				transportMode = google.maps.DirectionsTravelMode.DRIVING;
		}

		return map;
	};

	this.getTransportMode = function () {
		return transportMode;
	};

	this.getDirections = function (start, end) { // Optional argument for a results panel //
		var args = arguments,
			request = {
				origin:start,
				destination:end,
				travelMode: transportMode,
				unitSystem: google.maps.UnitSystem.IMPERIAL
			},
			result;

		DirectionsService.route(request, function(response, status) {
			if (status == google.maps.DirectionsStatus.OK) {
				directionsDisplay.setDirections(response);

				if (args[2]) { // Optional
					args[2].trigger('renderDirections', [response]);
				}
			}
		});

		return map;
	}
};

$('.form-directions').on('submit', function(event){
	event.preventDefault();

	$('.js-directions')
		.trigger('clearDirections');
	$(document.querySelector('.mode-select'))
		.trigger('updateHeight');

	var _form = $(this),
		_office = $('.offices .active'),
		_map = $('.js-contact-map'),
		_directions = $('.js-directions'),
		vals = _ad.qString('?'+_form.serialize()), // Prepend '?' so qString thinks it is a qualified query string //
		m = $('.js-map').data('map'),
		mode;

	vals.end =  'Botley Rd, West End, Southampton SO30 3XH';
	//vals.end =  'Utilita Bowl';
	switch (vals.mode) {
		case 'car':
			// vals.end =  'S030 3XH';
			break;
		case 'train':
			vals.end =  'Southampton Airport Parkway';
			break;
		case 'walk':
			// vals.end =  'Botley Rd, West End, Southampton SO30 3XH';
			break;
		case 'bicycle':
			// vals.end =  'S030 3XH';
			break;
		case 'intl':
			vals.end =  'Southampton Airport Parkway';
			// vals.start = 'Heathrow Airport';
			break;
		default:
			// vals.end =  'S030 3XH';
	}
	// vals.end =  'S030 3XH';

	if (vals.start && vals.end) {
		m.setTransportMode(vals.mode).getDirections(vals.start, vals.end, _directions);
	}
});

$('.js-page-directions').each(function(index, element){ // Code for the directions print page //
	var _this = $(element),
		_map = _this.find('.js-map'),
		_directions = _this.find('.js-directions'),
		map,
		mode;

	if (_ad.qString(window.location.search)) {
		var qString = _ad.qString(window.location.search),
			start = qString.start ? decodeURIComponent(qString.start) : false,
			end = qString.end ? decodeURIComponent(qString.end) : 'Utilita Bowl';


		_map.each(function(index, element){
			map = createMap(element, qString.end);

		}).on('mapIdle', function(){
			mode = getMode(qString.mode);

			if (end) {
				getDirections(qString.start, qString.end, mode, _map.data('directions'), _directions);
			}
		});
	}
});
// google.maps.event.addDomListener(window, 'load', initialize);
